import {CgArrowLongRightC} from "react-icons/cg";

function ForwardLink({href}) {
  const iconStyle = {
    pointerEvents: 'none',
    width: '24px',
    height: '24px',
  }

  return (
    <a href={href} title="Вперед" className="NavigationLink NavigationLink__right">
      <CgArrowLongRightC style={iconStyle} />
    </a>
  );
}

export default ForwardLink;
